import classNames from "classnames";

import { useRelationshipFilterSchema } from "shared/schemas/relationshipSchemas";

import FilterQueryPresentation from "features/ui/Filters/FilterBuilder/FilterQueryPresentation";
import { FilterDiffData } from "features/ui/Filters/types";
import { SchemaEntry } from "features/ui/MaterialTable";

interface Props {
  value: string;
  tableSchema?: SchemaEntry[];
  diff?: FilterDiffData;
  fieldName: string;
}

const ExistsFilterLabel = ({ value, tableSchema, diff, fieldName }: Props) => {
  // find the schema entry for this field to get the relationship schema
  const schemaEntry = tableSchema?.find(
    (entry) => entry.accessor === fieldName
  );
  const relationEndpoint = schemaEntry?.filter?.relationEndpoint;

  const lookupSchema = useRelationshipFilterSchema(relationEndpoint || "");
  const relationshipSchema = schemaEntry?.relationSchema ?? lookupSchema;

  const applyValueDiffStyle =
    diff?.changes[diff.level]?.[diff.groupIndex]?.[diff.rowIndex]?.values ??
    false;

  return (
    <div className="text-left">
      <div
        className={classNames(
          "ml-4",
          applyValueDiffStyle ? diff?.bgColor : undefined
        )}
      >
        <FilterQueryPresentation
          filter={value}
          tableSchema={relationshipSchema}
        />
      </div>
    </div>
  );
};

export default ExistsFilterLabel;
